import { AppRoutes } from '@utils/appRoutes';
import {
  FILLED_GIFT_CARD,
  GIFT_BOX,
  NEW_GIFT_BOX,
  NEW_GIFT_CARD,
} from '@utils/data';
import { cardBoxSectionType, faqContentType } from '@utils/types';

export const cardBoxSection: cardBoxSectionType[] = [
  {
    id: 1,
    title: 'Gift Box',
    description:
      'We’ve carefully curated our best meals and pantry items for you to send to the special foodie in your life. No matter their preferences, we have a gift box for you!',
    img: GIFT_BOX,
    alt: 'GIFT BOX',
    btnText: 'Bestsellers Gift Box',
    routes: AppRoutes.BESTSELLERS_GIFT,
    width: 350,
    height: 380,
  },
  {
    id: 2,
    title: 'Gift Card',
    description:
      'Have a friend who knows what they like? Let them choose their favorites when you give them the gift of food with a special gift card!',
    img: FILLED_GIFT_CARD,
    alt: 'GIFT CARD',
    btnText: 'Send a Gift Card',
    routes: AppRoutes.GIFT_CARD_STEP_ONE,
    width: 340,
    height: 225,
  },
];

export const faqContent: faqContentType[] = [
  {
    id: '1',
    title: 'How do the meal kits work?',
    ans: 'Our meal kits are ready to cook and take just 5 minutes of prep time.',
  },
  {
    id: '2',
    title: 'How does one prepare the meal kits?',
    ans: 'Typical instructions involve emptying the contents into a pan, adding water and cooking for about 5 minutes. All you need in addition to the meal kits is water and a pan.',
  },
  {
    id: '3',
    title: 'What is the shelf life of meal kits?',
    ans: 'Our meal kits have a minimum of 3 weeks of shelf life, from the date of delivery. You can store them at room temperature, except the rotis/theplas which need to be refrigerated once received.',
  },
  {
    id: '4',
    title: 'Do the meal kits come with sides?',
    ans: 'Yes, all meal kits come with necessary sides such as rotis/chutney/sambar/papad.',
  },
  {
    id: '5',
    title: 'Is shipping free?',
    ans: 'Yes, shipping is always free',
  },
];
